import i18n from "i18n";
export const ARCHIVE_RETENTION_IDS = {
  overrideId: "archive-retention-override-enabled",
  retentionTimeId: "archive-retention-time",
  globalId: "archive-retention-time-global"
};
const translate = (key) => i18n.t(key, { ns: "enterprise_data_tiering" });
export const getArchiveRetentionLabels = () => ({
  ...ARCHIVE_RETENTION_IDS,
  overrideLabel: translate("archive_retention_labels.override_label"),
  overrideHelp: translate("archive_retention_labels.override_help"),
  retentionTimeLabel: translate("archive_retention_labels.retention_time_label"),
  retentionTimeHelp: translate("archive_retention_labels.retention_time_help"),
  globalPlaceholder: translate("archive_retention_labels.global_placeholder"),
  globalHelp: translate("archive_retention_labels.global_help"),
  globalUnknownHelp: translate("archive_retention_labels.global_unknown_help")
});
export const globalRetentionHelp = (globalRetentionTime) => {
  const labels = getArchiveRetentionLabels();
  return globalRetentionTime === void 0 ? labels.globalUnknownHelp : labels.globalHelp;
};
